// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/ImportProfile.yaml
// Generated: 2026-03-17T14:51:29.877Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateImportProfile, UpdateImportProfile, ImportProfile } from '@/types/integration/ImportProfile';

/**
 * ImportProfile Service
 * CRUD operations for ImportProfile via the ABP API.
 */
export const importProfileService = new EntityService<ImportProfile, CreateImportProfile, UpdateImportProfile>(
  '/api/integration/importprofile',
  'ImportProfile',
);
